//弹框列表
const levelData = [{
        name: 'registerDialog',
        level: 0,
        ref: 'registerDialog',
        param: '',
        dialog: 'registerDialog',
        confirmfn: 'registerConfirmfn',
    },
    {
        name: 'locksetDialog',
        level: 0,
        ref: 'locksetDialog',
        param: '',
        dialog: 'locksetDialog',
        confirmfn: 'locksetFirmfn',
    },
    {
        name: 'chargeDialog',
        level: 0,
        ref: 'chargeDialog',
        param: '',
        dialog: 'chargeDialog',
        confirmfn: 'chargeFirmfn',
    },
    {
        name: 'howmuchDialog',
        level: 0,
        ref: 'howmuchDialog',
        param: '',
        dialog: 'howmuchDialog',
        confirmfn: 'howmuchDialogFn',
    },
    {
        name: 'refundDialog',
        level: 0,
        ref: 'refundDialog',
        param: '',
        dialog: 'refundDialog',
        confirmfn: 'refundFirmfn',
    },
    {
        name: 'returnComfirmDialog',
        level: 0,
        ref: 'returnComfirmDialog',
        param: '',
        dialog: 'returnComfirmDialog',
        confirmfn: 'returnComfirm',
    },
    {
        name: 'registerDetailDialog',
        level: 0,
        ref: 'registerDetailDialog',
        param: '',
        dialog: 'registerDetailDialog',
        confirmfn: 'locksetFirmfn',
    },
    {
        name: 'addPatientDialog',
        level: 0,
        ref: 'addPatientDialog',
        param: '',
        dialog: 'addPatientDialog',
        confirmfn: '',
    },
    {
        name: 'processingDialog',
        level: 0,
        ref: 'processingDialog',
        param: '',
        dialog: 'processingDialog',
        confirmfn: 'processingDialogConfirmfn',
    },
    {
        name: 'deliveryDialog',
        level: 0,
        ref: 'deliveryDialog',
        param: '',
        dialog: 'deliveryDialog',
        confirmfn: 'deliveryDialogConfirmfn',
    },
    {
        name: 'addressDialog',
        level: 0,
        ref: 'addressDialog',
        param: '',
        dialog: 'addressDialog',
        confirmfn: 'addressDialogConfirmfn',
    },
    {
        name: 'chargeRefundDialog',
        level: 0,
        ref: 'chargeRefundDialog',
        param: '',
        dialog: 'chargeRefundDialog',
        confirmfn: 'chargeRefundDialogConfirm',
    },
    {
        name: 'refundItemDialog',
        level: 0,
        ref: 'refundItemDialog',
        param: '',
        dialog: 'refundItemDialog',
        confirmfn: 'refundItemDialogComfirm',
    },
    {
        name: 'additionalPrescriptionDialog',
        level: 0,
        ref: 'additionalPrescriptionDialog',
        param: '',
        dialog: 'additionalPrescriptionDialog',
        confirmfn: 'additionalPrescriptionDialogConfimfn',
    },
    {
        name: 'pricingChargeDialog',
        level: 0,
        ref: 'pricingChargeDialog',
        param: '',
        dialog: 'pricingChargeDialog',
        confirmfn: 'pricingChargeConfirmfn',
    },
    {
        name: 'bargainDialog',
        level: 0,
        ref: 'bargainDialog',
        param: '',
        dialog: 'bargainDialog',
        confirmfn: '',
    },
    {
        name: 'yibaoDialog',
        level: 0,
        ref: 'yibaoDialog',
        param: '',
        dialog: 'yibaoDialog',
        confirmfn: '',
    },
    {
        name: 'refunDetailDialog',
        level: 0,
        ref: 'refunDetailDialog',
        param: '',
        dialog: 'refunDetailDialog',
        confirmfn: '',
    },
    {
        name: 'refuseDialog',
        level: 0,
        ref: 'refuseDialog',
        param: '',
        dialog: 'refuseDialog',
        confirmfn: 'refuseDialogConfirmfn',
    },

    {
        name: 'deleteAllDiagnosisDialog',
        level: 0,
        ref: 'deleteAllDiagnosisDialog',
        param: '',
        dialog: 'deleteAllDiagnosisDialog',
        confirmfn: '',
    },
    {
        name: 'executeDialog',
        level: 0,
        ref: 'executeDialog',
        param: '',
        dialog: 'executeDialog',
        confirmfn: 'executeDialogConfirmfn',
    },
    {
        name: 'executePrintDialog',
        level: 0,
        ref: 'executePrintDialog',
        param: '',
        dialog: 'executePrintDialog',
        confirmfn: 'executePrintDialogConfirmfn',
    },
    {
        name: 'executeDetail',
        level: 0,
        ref: 'executeDetail',
        param: '',
        dialog: 'executeDetail',
        confirmfn: '',
    },
    {
        name: 'executeBoardDialog',
        level: 0,
        ref: 'executeBoardDialog',
        param: '',
        dialog: 'executeBoardDialog',
        confirmfn: '',
    },

    {
        name: 'dataDoardDialog',
        level: 0,
        ref: 'dataDoardDialog',
        param: '',
        dialog: 'dataDoardDialog',
        confirmfn: '',
    },
    {
        name: 'callNumDialog',
        level: 0,
        ref: 'callNumDialog',
        param: '',
        dialog: 'callNumDialog',
        confirmfn: '',
    },
    {
        name: 'printDetailDialog',
        level: 0,
        ref: 'printDetailDialog',
        param: '',
        dialog: 'printDetailDialog',
        confirmfn: '',
    },
]

// 可现实区域
const visibleObj = {
    registerDialog: false, //挂号弹框
    locksetDialog: false, //锁号弹框
    chargeDialog: false, //收费弹框
    howmuchDialog: false, //howmuch弹框
    refundDialog: false, //退费弹框
    returnComfirmDialog: false, //退号确认弹框
    registerDetailDialog: false, //挂号详情弹框
    addPatientDialog: false, //新增患者弹框
    processingDialog: false, //加工弹框
    deliveryDialog: false, //快递弹框
    addressDialog: false, //地址弹框
    chargeRefundDialog: false, //退费弹框
    refundItemDialog: false, //退费项目弹框
    additionalPrescriptionDialog: false, //补录处方弹框
    pricingChargeDialog: false, //划价收费弹框
    bargainDialog: false, //议价弹框
    yibaoDialog: false, //医保弹框
    refunDetailDialog: false, //退费详情
    refuseDialog: false, //拒绝订单
    executeDialog: false, //理疗执行弹框
    executePrintDialog: false, //理疗打印预览弹框
    executeDetail: false, //理疗详情弹框
    executeBoardDialog: false, //执行看板弹框
    deleteAllDiagnosisDialog:false,//删除就诊草稿信息
    dataDoardDialog:false,//门诊数据看板弹框
    callNumDialog:false,//门诊叫号弹框
    printDetailDialog:false,//打印详情弹框
}


export { levelData, visibleObj }